import React, { useEffect } from "react";
import { Form, Input, InputNumber, Button, Checkbox, Select } from "antd";
import { LoadingIcon } from "../../../components";
const { Option } = Select;

const EditModalContent = ({ data, setOpen, updateCallback, cropData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      name: data?.name,
      maximum_site_allowed: data?.maximum_site_allowed,
      maximum_user_allowed: data?.maximum_user_allowed,
      maximum_crop_allowed: data?.maximum_crop_allowed,
      maximum_plot_allowed: data?.maximum_plot_allowed,
      is_active: data?.is_active,
      is_breeder: data?.is_breeder,
      is_grower: data?.is_grower,
      is_pollination: data?.is_pollination,
      crops: data?.crops ? data.crops.map((c) => c.id) : [],
    });
  }, [data, form]);

  const onFinish = (values) => {
    console.log("Success:", values);
    const editData = { ...data, ...values };
    updateCallback(editData);
    form.resetFields();
    setOpen(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="editOrgForm"
        className="max-w-[80%]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          name: data?.name,
          maximum_site_allowed: data?.maximum_site_allowed,
          maximum_user_allowed: data?.maximum_user_allowed,
          maximum_crop_allowed: data?.maximum_crop_allowed,
          maximum_plot_allowed: data?.maximum_plot_allowed,
          is_active: data?.is_active,
          is_breeder: data?.is_breeder,
          is_grower: data?.is_grower,
          is_pollination: data?.is_pollination,
          crops: data?.crops ? data.crops.map((c) => c.id) : [],
        }}
      >
        <Form.Item
          className="mr-2"
          name="name"
          label="Name"
          initialValue={`${data?.name}`}
          rules={[
            {
              required: true,
              message: "name required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="maximum_site_allowed"
            label="Max Site"
            initialValue={data?.maximum_site_allowed}
            rules={[
              {
                required: true,
                message: "max Site required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="maximum_user_allowed"
            label="Max User"
            initialValue={data?.maximum_user_allowed}
            rules={[
              {
                required: true,
                message: "max User required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="maximum_crop_allowed"
            label="Max Crop"
            initialValue={data?.maximum_crop_allowed}
            rules={[
              {
                required: true,
                message: "max Crop required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="maximum_plot_allowed"
            label="Max Plot"
            initialValue={data?.maximum_plot_allowed}
            rules={[
              {
                required: true,
                message: "max Plot required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="is_active"
            valuePropName="checked"
            initialValue={data?.is_active}
            label="Active"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="is_breeder"
            initialValue={data?.is_breeder}
            valuePropName="checked"
            label="Breeder"
          >
            <Checkbox />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="is_grower"
            initialValue={data?.is_grower}
            valuePropName="checked"
            label="Grower"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="is_pollination"
            initialValue={data?.is_pollination}
            valuePropName="checked"
            label="Pollination"
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item
          name="crops"
          label="Select Crops"
          rules={[
            { required: true, message: "Please select at least one crop" },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select Crops"
            notFoundContent={cropData ? <LoadingIcon /> : null}
            // Optionally, you can allow search:
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children || "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {cropData?.map((crop) => (
              <Option key={crop.id} value={crop.id}>
                {crop.display_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditModalContent;
